import React from "react";
import propTypes from "prop-types";
import { DefaultPageContainer as PageContainer } from "@layout";
import { BusinessInfo } from "@molecules";
import { ContactSection } from "@organisms";

const ContactPage = ({ data }) => {
  const { services, map, meta } = data;
  return (
    <PageContainer meta={meta}>
      <ContactSection services={services} />
      <BusinessInfo image={map} />
      <div className="h-full w-full absolute bg-soft-red-blue-gradient bg-gradient-from-right top-0 z-[-10] opacity-20" />
    </PageContainer>
  );
};

ContactPage.defaultProps = {};

ContactPage.propTypes = {};

export default ContactPage;
